import _ from "underscore";
import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getInitialState, getUnloadedState } from "./state";
import { deepCopy } from "@/store/helpers";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.VIEW_STARTED](state, key) {
    state.estimator.loading = true;
    state.estimator.key = key;
    state.playground.loading = true;
    state.playground.key = key;
  },
  [mutation.VIEW_SUCCEEDED](state, result) {
    state.estimator.loading = false;
    state.estimator.loaded = true;
    state.playground.loading = false;
    state.playground.loaded = true;
    stateMerge(state.estimator.data, deepCopy(result));
    const list = state.estimator.data.templates;
    state.estimator.data.indexedTemplates = _.object(_(list).pluck("type"), _(list).pluck("html"));
    stateMerge(state.playground.data, deepCopy(state.estimator.data));
    resetPlaygroundParameters(state);
    state.playground.parameters = deepCopy(state.playground.edit);
  },
  [mutation.VIEW_FAILED](state) {
    state.estimator.loading = false;
    state.estimator.loaded = false;
  },

  [mutation.PUBLIC_ESTIMATOR_GET_STARTED](state, { type, year }) {
    state.publicEstimator.type = type;
    state.publicEstimator.year = year;
    state.publicEstimator.loading = true;
  },
  [mutation.PUBLIC_ESTIMATOR_GET_SUCCEEDED](state, result) {
    state.publicEstimator.loading = false;
    state.publicEstimator.loaded = true;
    state.publicEstimator.unavailable = null;
    stateMerge(state.publicEstimator.data, result);
    const list = state.publicEstimator.data.templates;
    state.publicEstimator.data.indexedTemplates = _.object(_(list).pluck("type"), _(list).pluck("html"));
    stateMerge(state.publicEstimator.edit, deepCopy(state.publicEstimator.data.levyCollectionProvider.levyParameters));
    setExemptions(state.publicEstimator.edit);
  },
  [mutation.PUBLIC_ESTIMATOR_GET_FAILED](state, error) {
    state.publicEstimator.loading = false;
    state.publicEstimator.loaded = false;
    let message = "The levy estimator for this levy collection is not available.";
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors[0].messages
    ) {
      message = error.response.data.errors[0].messages[0];
    }
    state.publicEstimator.unavailable = message;
  },
  [mutation.PUBLIC_ESTIMATOR_UPDATE](state, updates) {
    stateMerge(state.publicEstimator.edit, updates);
  },
  [mutation.PUBLIC_ESTIMATOR_CALCULATE_STARTED](state) {
    state.publicEstimator.processing = true;
  },
  [mutation.PUBLIC_ESTIMATOR_CALCULATE_SUCCEEDED](state, result) {
    state.publicEstimator.processing = false;
    stateMerge(state.publicEstimator.data, result);
  },
  [mutation.PUBLIC_ESTIMATOR_CALCULATE_FAILED](state) {
    state.publicEstimator.processing = false;
  },

  [mutation.PLAYGROUND_EDIT_RESET](state) {
    resetPlaygroundParameters(state);
  },
  [mutation.PLAYGROUND_EDIT_UPDATE](state, updates) {
    stateMerge(state.playground.edit, updates);
  },
  [mutation.PLAYGROUND_EDIT_START](state) {
    state.playground.edit = deepCopy(state.playground.parameters);
  },
  [mutation.PLAYGROUND_EDIT_APPLY](state) {
    state.playground.parameters = deepCopy(state.playground.edit);
    state.playground.active = true;
  },
  [mutation.PLAYGROUND_EDIT_QUIT](state) {
    state.playground.active = false;
  },

  [mutation.PLAYGROUND_CALCULATE_STARTED](state, key) {
    state.playground.loading = true;
    state.playground.key = key;
  },
  [mutation.PLAYGROUND_CALCULATE_SUCCEEDED](state, result) {
    state.playground.loading = false;
    state.playground.loaded = true;
    stateMerge(state.playground.data, result);
  },
  [mutation.PLAYGROUND_CALCULATE_FAILED](state) {
    state.playground.loading = false;
  }
};

function resetPlaygroundParameters(state) {
  stateMerge(state.playground.edit, deepCopy(state.estimator.data.levyCollectionProvider.levyParameters));
  setExemptions(state.playground.edit);
}

function setExemptions(data) {
  if (data.administrationFeeExempt == null) {
    data.administrationFeeExempt = false;
  }
  if (data.riskRatingExempt == null) {
    data.riskRatingExempt = false;
  }
  if (data.specialTuitionProtectionExempt == null) {
    data.specialTuitionProtectionExempt = false;
  }
}
